export const SAGA_KEY_GOALS_ADMIN = 'goalsAdmin';
export const RULES_PRODUCT_TEMPLATES = 'rulesProductTemplates';
export const DEALS_PRODUCT_TEMPLATES = 'dealsProductTemplates';
export const ONE_TIME_ACTIONS_PRODUCT_TEMPLATES = 'oneTimeActionsProductTemplates';
export const GOAL = 'goal';
export const GOALS = 'goals';
